import React from "react";
import set from "@rill/set";

import { ProgramMetrics } from "./ProgramMetrics";
import moment from "moment";

const FEED_LIMIT = 15;

// we default it to six months to have some initial data for the live feed
const DEFAULT_WEEK_FROM = "six-months";
const mainDateRanges = {
  "two-weeks": moment().subtract(2, "weeks").format("YYYYMMDD"),
  "one-month": moment().subtract(1, "months").format("YYYYMMDD"),
  "three-months": moment().subtract(3, "months").format("YYYYMMDD"),
  "six-months": moment().subtract(6, "months").format("YYYYMMDD"),
  lifetime: undefined,
};

// Default will be 12 months
const DEFAULT_SELECTED_PROGRAM_MONTH_FROM = "twelve-months";
const asideDateRanges = {
  "twelve-months": moment().subtract(12, "months").format("YYYYMMDD"),
  "twenty-four-months": moment().subtract(24, "months").format("YYYYMMDD"),
  "thirty-six-months": moment().subtract(36, "months").format("YYYYMMDD"),
};

const ProgramMetricsController = (app) => {
  app.get(
    "/program-metrics",
    set("heading", "Program Metrics"),
    async ({ res, req, locals, load }) => {
      const { query } = req;
      let { weekFrom, monthFrom, lifetime, selectedProgramId, pagination } =
        query;

      locals.query.feedLimit = FEED_LIMIT;

      if (!weekFrom) {
        locals.query.weekFrom = DEFAULT_WEEK_FROM;
      }
      if (!monthFrom) {
        locals.query.monthFrom = DEFAULT_SELECTED_PROGRAM_MONTH_FROM;
      }

      // We will receive keys of weeks/months in the case of the main graph date change
      weekFrom = lifetime
        ? mainDateRanges[weekFrom]
        : mainDateRanges[weekFrom] || mainDateRanges[DEFAULT_WEEK_FROM];

      // We will receive keys of months in the case of the aside graph date change
      monthFrom =
        asideDateRanges[monthFrom] ||
        asideDateRanges[DEFAULT_SELECTED_PROGRAM_MONTH_FROM];

      try {
        await load("programMetrics", {
          dateFrom: weekFrom, // sent as utcDate --> 'YYYYMMDD'
        });

        // If we don't have a program selected, we default it to the first that we are receiving
        selectedProgramId =
          selectedProgramId || locals.programMetrics?.[0]?.metadata?.programId;
        locals.query.selectedProgramId = selectedProgramId; // this helps us set a selected program by default

        await load("selectedProgramMetrics", {
          dateFrom: monthFrom, // sent as utcDate --> 'YYYYMMDD'
          selectedProgramId,
        });

        await load("programMetricsFeed", {
          pagination: pagination ? Number(pagination) : 1,
          limit: FEED_LIMIT,
          sort: -1,
        });
      } catch (error) {
        console.error(error);
      }

      res.body = <ProgramMetrics locals={locals} />;
    }
  );
};

export default ProgramMetricsController;
